export { default } from './RelateStatementQuizStep';
